<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-02 09:07:09
 * @LastEditTime: 2022-03-03 15:43:13
-->
<template>
  <div class="navbar-tab">
    <div style="display: flex">
      <div 
        :class="websiteType ==='deviceManagement' ? 'device-management-active' : 'devices-management'"
        @click="clickTab('deviceManagement')">
        {{$t('lang.navTab.devicesManagement')}}
      </div>
      <div 
        v-if="monState == 1"
        :class="websiteType ==='cloudMonitor' ? 'cloud-monitor-active' : 'cloud-monitor'"
         @click="clickTab('cloudMonitor')">
        {{$t('lang.navTab.monitorCloud')}}
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { GetMonitor, SetMonitor } from '@/localStorage/localStorage'
import {getUserDetails} from '@/api/navbar'
export default {
  props:['websiteType'],
  data() {
    return {
      monState: 0,
    }
  },
  created() {   
    getUserDetails().then(res => {
      this.monState = res.data.data.monState
      SetMonitor(this.monState)
    })
  },
  methods: {
    clickTab(type) {
      // 切换为另一个服务系统
      if(this.websiteType !== type) {
        let newPage = ''
        if(type === 'deviceManagement'){
          console.log('deviceManagement ---');
          // this.$store.dispatch('GetWbsiteType', 'deviceManagement')
          newPage = this.$router.resolve({
            path: '/dashboard'
          })
        }else if(type === 'cloudMonitor') {
          console.log('cloudMonitor ---');
           newPage = this.$router.resolve({
            path: '/cloudMonitor/cloudMonitorHome'
          })
        }
        window.open(newPage.href, '_self')
      }
    }
  }
}
</script>
<style scoped>
.navbar-tab{
    /* background-color: #f5f5f5; */
    /* line-height: 10vh; */
    line-height: 8vh;
    display: inline-block;
    margin-left: 20px;
    color: #ffffff;
    font-size: 15px;
    /* transform: translateY(-4px); */
  
}
.cloud-monitor, .devices-management{
  cursor: pointer;
  min-width: 100px;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
}
.cloud-monitor:hover{
  background-color: #38ace2;
}
.devices-management:hover{
  background-color: #38ace2;
}
.cloud-monitor-active, .device-management-active{
  background-color: #38ace2;
  cursor: pointer;
  min-width: 100px;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
}
.cloud-monitor-active:hover{
  cursor: pointer;
}
.device-management-active:hover {
  cursor: pointer;
}
</style>